/**
 * @generated SignedSource<<afed33f258e9c4a8c77245390d6accfa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditAnnouncementMessage_chat_updateMessage_Mutation$variables = {
  id: string;
  text: UnknownJSON;
};
export type EditAnnouncementMessage_chat_updateMessage_Mutation$data = {
  readonly updateMessage: {
    readonly " $fragmentSpreads": FragmentRefs<"EditMessage_chat_messageFragment">;
  };
};
export type EditAnnouncementMessage_chat_updateMessage_Mutation = {
  response: EditAnnouncementMessage_chat_updateMessage_Mutation$data;
  variables: EditAnnouncementMessage_chat_updateMessage_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "text"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "messageId",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "text",
        "variableName": "text"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditAnnouncementMessage_chat_updateMessage_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Message",
        "kind": "LinkedField",
        "name": "updateMessage",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EditMessage_chat_messageFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditAnnouncementMessage_chat_updateMessage_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Message",
        "kind": "LinkedField",
        "name": "updateMessage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Conversation",
            "kind": "LinkedField",
            "name": "conversation",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "participants",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Reference",
                "kind": "LinkedField",
                "name": "reference",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "internal_id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ed326771a49910f5e3105153d60ff5c2",
    "id": null,
    "metadata": {},
    "name": "EditAnnouncementMessage_chat_updateMessage_Mutation",
    "operationKind": "mutation",
    "text": "mutation EditAnnouncementMessage_chat_updateMessage_Mutation(\n  $id: ID!\n  $text: JSON!\n) {\n  updateMessage(input: {messageId: $id, text: $text}) {\n    ...EditMessage_chat_messageFragment\n    id\n  }\n}\n\nfragment EditMessage_chat_messageFragment on Message {\n  id\n  text\n  conversation {\n    id\n    participants\n    reference {\n      internal_id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "608a53eb703ceeba433a5b13dc7d53b2";

export default node;
